<script>
let customerId = window.localStorage.getItem("customerId");
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button, Select } from "view-design";
import ImportTemplate from "@/views/components/common/form/commonImportTemplate.vue";
import config from "@/../config";
import detailsVue from "./details.vue";

export default {
  extends: baseList,
  components: {
    detailsVue,
  },
  data() {
    return {
      table: {
        mname: "commondescr",
        key: "id",
        url: {
          del: "/admin/system/common",
          list: "/admin/system/common/publicList",
        },
        output: false,
      },
      query: {
        state: 1,
      },
      actions: [
        // {
        //     label: "新增",
        //     icon: "md-add",
        //     type: "info",
        //     onClick: this.toAdd,
        //     auth: "system/commondescr/add",
        // },
        // {
        //     label: "导入字典",
        //     icon: "md-cloud-upload",
        //     onClick: this.toImport,
        //     auth: "",
        //     type: "info",
        // },
        // {
        //     label: "下载模板",
        //     icon: "md-log-out",
        //     onClick: this.toDownload,
        //     auth: "system/commondescr/download",
        //     type: "info",
        // },
        // {
        //   label: "导出字典",
        //   icon: "md-download",
        //   type: "info",
        //   onClick: this.exportData.bind(this, "服务字典列表", 6),
        //   auth: "system/commondescr/exportData",
        // },
      ],
      menus: [
        {
          label: "知识库",
          name: "issueKnowledgeBase",
          auth: "",
        },
        {
          label: "知识库审核",
          name: "auditKnowledgeBase",
          auth: "",
        },
      ],
      // menus: [
      //   {
      //     label: "常用语",
      //     name: "commondescr_list_main",
      //     auth: "system/commondescr/index",
      //   },
      //   {
      //     label: "服务字典",
      //     name: "serveKnowledgeBase",
      //     auth: "system/commondescr/index",
      //   },
      //   {
      //     label: "知识库",
      //     name: "issueKnowledgeBase",
      //     auth: "system/commondescr/index",
      //   },
      //   {
      //     label: "知识库审核",
      //     name: "auditKnowledgeBase",
      //     auth: "system/commondescr/index",
      //   },
      //   {
      //     label: "工单类型",
      //     name: "worktype_list",
      //     auth: "system/worktype/index",
      //   },
      //   // {
      //   //   label: "供应商",
      //   //   name: "supplier_main",
      //   //   auth: "system/supplier/index",
      //   // },
      //   {
      //     label: "资产类型",
      //     name: "deviceClass_list",
      //     auth: "system/deviceClass/index",
      //   },
      //   {
      //     label: "型号库",
      //     name: "deviceType_list",
      //     auth: "",
      //   },
      //   {
      //     label: "耗材分类",
      //     name: "consumablesClass_list",
      //     auth: "system/consumablesClass/index",
      //     show: !(Number(customerId) === 0),
      //   },
      //   {
      //     label: "楼宇管理",
      //     name: "offices_building_list",
      //     auth: "system/offices/index",
      //   },
      //   // {
      //   //   label: "巡检模板",
      //   //   name: "templateManagement_list",
      //   //   auth: "system/templateManagement/index",
      //   // },
      //   {
      //     label: "巡检类别",
      //     name: "category_list",
      //     auth: "system/category/index",
      //   },
      //   {
      //     label: "巡检项",
      //     name: "scene_list",
      //     auth: "system/scene/index",
      //   },
      //   {
      //     label: "坐席列表",
      //     name: "callConfig_list",
      //     auth: "/admin/callConfig/lists",
      //   },

      //   {
      //     label: "投诉管理",
      //     name: "feedback_list",
      //     auth: "/admin/feedback/lists",
      //   },
      //   {
      //     label: "流程管理",
      //     name: "approvalProcess_list",
      //     auth: "",
      //   },

      // ],
      filters: [
        {
          label: "字典内容",
          name: "descr",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "工单类型",
          name: "workTypeId",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [],
        },
      ],
      tableCols: [
        {
          // type: "selection",
          type: "index",
          title: "序号",
          width: 80,
          align: "center",
        },
        // {
        //   title: '类型',
        //   key: 'workType',
        //   width: 120,
        //   align: 'center',
        //   render: (h, params) => {
        //     const row = params.row
        //     const text = row.workType == 1 ? "报修内容" : ''
        //     return (
        //       <span>{text}</span>
        //     );
        //   },
        // },
        {
          title: "内容",
          // key: "workTypeName",
          // minWidth: 0,
          align: "left",
          tooltip: "true",
          render: (h, p) => {
            let item = p.row;
            // console.log(item);
            let directives = [
              { name: "auth", value: "system/commondescr/details" },
            ];
            return (
              <div style={{ fontSize: "16px" }}>
                <span>[{item.workTypeName}] </span>
                <span
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toDetails(item)}
                  type="default"
                  style={{ color: "#4991ff", cursor: "pointer" }}
                >
                  {" "}
                  {item.descr}
                </span>

                <span
                  style={{ margin: "0 0 0 5px" }}
                  onClick={() => this.adopt(item)}
                >
                  <Icon
                    type="ios-cloud-download-outline"
                    size="18"
                    color="#000"
                  />
                </span>
              </div>
            );
          },
        },
        // {
        //     title: "字典内容",
        //     minWidth: 180,
        //     align: "left",
        //     key: "descr",
        // },

        // {
        //   title: "推荐方案",
        //   key: "recommendation",
        //   minWidth: 200,
        //   align: "left",
        //   tooltip: "true",
        // },

        // {
        //     title: "操作",
        //     align: "center",
        //     minWidth: 180,
        //     key: "handle",
        //     handle: [(vm, h, currentRow, param) => {
        //         // let directives = []
        //         let directives = [
        //             { name: "auth", value: "system/commondescr/details" },
        //         ];
        //         return (
        //             <Button
        //                 {...{ directives }}
        //                 size="small"
        //                 onClick={() => this.toDetails(currentRow)}
        //                 type="default"
        //                 style={{ border: "none", marginLeft: "5px", marginRight: "5px", color: "#4991ff" }}
        //             >
        //                 详情
        //             </Button>
        //         );
        //     }, (vm, h, currentRow, param) => {
        //         // let directives = []
        //         let directives = [
        //             { name: "auth", value: "system/commondescr/details" },
        //         ];
        //         return (
        //             <Button
        //                 {...{ directives }}
        //                 size="small"
        //                 onClick={() => this.adopt(currentRow)}
        //                 type="default"
        //                 style={{ border: "none", marginLeft: "5px", marginRight: "5px", color: "#4991ff" }}
        //             >
        //                 采用
        //             </Button>
        //         );
        //     }],
        // },
      ],
      selectList: [],
      selectItem: "",
    };
  },
  created() {
    this.loadLevelDatas();
  },
  methods: {
    loadLevelDatas() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api
        .load("/admin/system/workType/selectListAdmin", q)
        .then((res) => {
          if (res && res.rows) {
            let ll = res.rows;
            let dropList = [];
            for (let index = 0; index < ll.length; index++) {
              const element = ll[index];
              let xx = {};
              xx.value = element.id;
              xx.name = element.name;
              xx.children = element.children || [];
              dropList.push(xx);
            }
            for (let index = 0; index < this.filters.length; index++) {
              const element = this.filters[index];
              if (element && element.name == "workTypeId") {
                this.filters[index]["dropList"] = (
                  element["dropList"] || []
                ).concat(dropList);
              }
            }
          }
        });
    },
    //导入
    toImport() {
      this.$Modal.success({
        closable: true,
        title: "导入模板",
        width: "1200px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <ImportTemplate
              style={{ margin: "0", color: "#19be6b" }}
              refListTable={() => {
                this.search();
              }}
            ></ImportTemplate>
          );
        },
      });
    },
    //下载模板
    toDownload() {
      window.location.href =
        config.API_HOST + `/admin/system/common/template/download`;
    },
    toAdd() {
      $utils.url.push({
        name: "commondescr_add",
        query: { action: "add", type: 2 },
      });
    },
    handleEdit(currentRow) {
      $utils.url.push({
        name: "commondescr_edit",
        query: { action: "edit", kv: currentRow.id },
      });
    },
    toDetails(currentRow) {
      let that = this;
      // console.log(currentRow);
      // $utils.url.push({
      //   name: "knowledgeBaseDetails",
      //   query: { id: currentRow.id, type: 1 },
      // });
      let customComponent = this.$createElement(detailsVue, {
        props: {
          row: currentRow,
          type: 1,
        },
      });
      this.$drawer.show({
        visible: true,
        title: currentRow.workTypeName,
        size: "50%",
        direction: "rtl",
        content: customComponent,
        beforeClose: () => {
          // 在关闭抽屉前执行一些操作
        },
      });
    },
    async loadworkData() {
      let q = {};
      let res = await $utils.api.load(`/admin/system/workType/list`, q);
      if (res && res.rows) {
        console.log(res);
        this.selectList = res.rows;
      }
    },
    async adoptLoad(currentRow) {
      if (this.selectItem) {
        let q = {
          id: currentRow.id,
          workType: 1,
          workTypeId: this.selectItem,
        };
        console.log(q);
        let res = await $utils.api.load(
          `/admin/system/common/usePublic`,
          q,
          "post"
        );
        // console.log(res);
        if (res.code == 200) {
          this.$Modal.remove();
          $utils.toast.success("采用成功！");
          this.search();
        }
      } else {
        $utils.toast.warn("工单类型不能为空！");
      }
    },
    async adopt(currentRow) {
      this.selectItem = "";
      this.loadworkData();
      this.$Modal.success({
        closable: true,
        title: "确认采用知识文档到本地服务字典吗？",
        width: "800px",
        height: "80px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              <div style="margin:40px 0">
                <Form>
                  <FormItem required={true} label="工单类型：">
                    <Select
                      style="width: 200px;"
                      vModel={this.selectItem}
                      clearable={true}
                    >
                      {this.selectList.map((item) => {
                        return <Option value={item.id}>{item.name}</Option>;
                      })}
                    </Select>
                  </FormItem>
                </Form>
                {/* <span style="margin:0 40px 0 0">工单类型：</span> */}
              </div>
              <div style="display:flex; justify-content: center;">
                <Button
                  type="primary"
                  style={{ margin: "0 20px 0 0" }}
                  onClick={() => {
                    this.adoptLoad(currentRow);
                  }}
                >
                  确认
                </Button>
                <Button
                  type="primary"
                  onClick={() => {
                    this.$Modal.remove();
                  }}
                >
                  取消
                </Button>
              </div>
            </div>
          );
        },
      });
      // let q = {}
      // // console.log(currentRow);
      // let res = await $utils.api.load(`/admin/system/common/usePublic/${currentRow.id}`, q, 'post')
      // // console.log(res);
      // if (res.code == 200) {
      //     $utils.toast.success("采用成功！");
      //     this.search()
      // }
    },
    //转单
    // toChange(row) {},
    //详情
    // toInfo(row) {
    //   $utils.url.push({
    //     name: 'knowledgeBase_info',
    //     query: { action: 'edit', kv: row.id },
    //   })
    // },
  },
};
</script>
<style scoped></style>
